import Vue from 'vue';

Vue.component('datatable-header', require('./datatable-header.vue'));



// WEBPACK FOOTER //
// ./resources/assets/js/components/datatable-header/index.js